import {useEffect, useState} from "react";

type rawData = { id?: number, first_name: string, last_name: string, avatar: string | null }[]

export const useContacts = (initialData: any) => {

    const [data, setData] = useState<rawData>(initialData)
    const [sign, setSign] = useState('')

    let normalizeContactRecord = (record: any) => {
        if (record.avatar && !String(record.avatar).startsWith('http'))
            record.avatar = process.env.REACT_APP_API_URL + '/images/avatar/' + record.avatar
        return record
    }

    useEffect(() => {
        if (initialData) {
            if (initialData.length === 0) {
                setData([])
            } else {
                setData(initialData.map((e: any) => normalizeContactRecord(e)))
            }
        }
    }, [initialData])

    useEffect(() => {
        setSign(JSON.stringify(data))
    }, [data])


    return {
        sign,
        list: (data ? data : []),
        get: (id: number | string): keyof rawData | boolean => {
            if (!data)
                return false
            let items = data.filter((contact) => Number(contact?.id) === Number(id))
            if (items.length > 0)
                return Object(items[0])
            return false
        },

        delete: (id: number | string): boolean => {
            if (!data)
                return false
            setData(data.filter((contact) => Number(contact.id) !== Number(id)))
            return true
        },
        update: (item: keyof rawData): void => {
            if (!data || (Array.isArray(data) && data.length === 0)) {
                setData([normalizeContactRecord(item)])
            } else {
                let found = false

                let bewData = data.map((el: any) => {
                    if (el?.id && Object(item)?.id && Number(el.id) === Number(Object(item).id)) {
                        found = true
                        return normalizeContactRecord(item)
                    }
                    return el
                })

                if (!found)
                    bewData = [item].concat(bewData)

                setData(bewData)
            }
        }
    }
}
